import {atom} from 'recoil'

export const addTaskModalState = atom<any>({
    key: 'AddTaskModalState',
    default: false
})

export const selectedPrintData = atom<any>({
  key: 'SelectedPrintData',
  default: undefined
})